import { Link } from 'react-router-dom';

const shortcuts = [
  { label: 'Editar Hero', desc: 'Imagem, título e botões', icon: 'ri-image-line', path: '/admin/hero', color: 'bg-amber-50 text-amber-600' },
  { label: 'Seções da Home', desc: 'Todas as seções da página inicial', icon: 'ri-layout-line', path: '/admin/sections/home', color: 'bg-emerald-50 text-emerald-600' },
  { label: 'Páginas Internas', desc: 'Whiskies, Gins, Nossa História...', icon: 'ri-pages-line', path: '/admin/sections/pages', color: 'bg-sky-50 text-sky-600' },
  { label: 'Logomarca', desc: 'Header e footer logo', icon: 'ri-trademark-line', path: '/admin/logo', color: 'bg-violet-50 text-violet-600' },
  { label: 'Cores do Site', desc: 'Paleta e identidade visual', icon: 'ri-palette-line', path: '/admin/colors', color: 'bg-pink-50 text-pink-600' },
  { label: 'Footer', desc: 'Textos, links e redes sociais', icon: 'ri-layout-bottom-line', path: '/admin/footer', color: 'bg-orange-50 text-orange-600' },
  { label: 'Biblioteca de Mídia', desc: 'Upload e gestão de imagens', icon: 'ri-image-2-line', path: '/admin/media', color: 'bg-teal-50 text-teal-600' },
  { label: 'Configurações', desc: 'Nome do site, favicon, contato', icon: 'ri-settings-3-line', path: '/admin/settings', color: 'bg-gray-100 text-gray-600' },
];

export default function AdminDashboard() {
  return (
    <div>
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-2xl font-semibold text-gray-800" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
          Painel Administrativo
        </h1>
        <p className="text-gray-500 text-sm mt-1">Gerencie todo o conteúdo do site Ma Gádeni</p>
      </div>

      {/* Quick access */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-10">
        {shortcuts.map((s) => (
          <Link
            key={s.path}
            to={s.path}
            className="bg-white rounded-xl p-5 border border-gray-100 hover:border-[#C9A84C]/30 hover:-translate-y-0.5 transition-all cursor-pointer group"
          >
            <div className={`w-10 h-10 flex items-center justify-center rounded-lg ${s.color} mb-3`}>
              <i className={`${s.icon} text-lg`}></i>
            </div>
            <p className="text-gray-800 font-medium text-sm">{s.label}</p>
            <p className="text-gray-400 text-xs mt-0.5">{s.desc}</p>
          </Link>
        ))}
      </div>

      {/* Info banner */}
      <div className="bg-[#111111] rounded-xl p-6 flex items-center gap-5">
        <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#C9A84C]/15 shrink-0">
          <i className="ri-information-line text-[#C9A84C] text-xl"></i>
        </div>
        <div>
          <p className="text-white font-medium text-sm">Bem-vindo ao painel Ma Gádeni</p>
          <p className="text-white/40 text-xs mt-0.5">
            Todas as alterações são salvas automaticamente no banco de dados e refletidas no site em tempo real.
            Use o menu lateral para navegar entre as seções.
          </p>
        </div>
        <a
          href="/"
          target="_blank"
          rel="noopener noreferrer"
          className="ml-auto shrink-0 bg-[#C9A84C] hover:bg-[#D4AF37] text-black text-xs font-semibold px-4 py-2 rounded-lg whitespace-nowrap cursor-pointer transition-colors"
        >
          Ver Site
        </a>
      </div>
    </div>
  );
}
